import * as React from 'react'
import { WithStyles, Typography, Icon, Theme, createStyles, withStyles } from '@material-ui/core'
import ReactHtmlParser from 'react-html-parser'
import { formatDate } from 'src/core/i18n/date'
import { compose } from 'redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { getNews } from 'src/core/redux/action/newsAction'
import { getIdFormYoutubeUrl, getFileExtension } from 'src/shared/utils/helpers'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import PcDialog from 'src/shared/Dialog/PcDialog'
import autobind from 'autobind-decorator'
import YouTube from 'react-youtube'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import {css} from 'src/conf/style'
import NewsShare from 'src/shared/News/NewsShare'
import { NewsTags } from 'src/shared/News/NewsTags'

const styles = (t: Theme) => createStyles({
    postImg: {
        display: 'block',
        width: '100%',
        height: 'auto',
    },
    tagsWpr: {
        ...css.flexAlCenter,
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    newsPostHeading: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginTop: t.spacing.unit * 3
    },
    seeVideoBg: {
        position: 'absolute',
        height: 0,
        width: 0,
        bottom: 0,
        right: 0,
        borderStyle: 'solid',
        borderWidth: '0 0 12vmax 12vmax',
        borderColor: 'transparent  transparent rgba(0,0,0,.6) transparent',
    },
    imgWpr: {
        position: 'relative'
    },
    chip: {
        margin: '5px'
    },
    documentWpr: {
        ...css.flexAlCenter
    },
    documentUrl: {
        ...css.flexAlCenter,
        margin: t.spacing.unit * 2,
        color: t.palette.primary.main,
        textDecoration: 'none',
        fontStyle: 'italic',
    },
    newsExpWpr: {
        boxShadow: 'none'
    },
    seeVideo: {
        position: 'absolute',
        bottom: t.spacing.unit,
        right: t.spacing.unit,
        marginLeft: t.spacing.unit,
        color: t.palette.primary.main,
        cursor: 'pointer',
        fontSize: '5vmax'
    },
    video: {
        [t.breakpoints.up('sm')]: {
            minWidth: '1200px',
            minHeight: '480px'
        },
    },
    documentImg: {
        width: '55px',
        height: '55px',
        borderRadius: '0 !important'
    }
});

const opts = {
    width: '100%',
    playerVars: { // https://developers.google.com/youtube/player_parameters
      autoplay: 1
    }
};

  
interface IProps extends WithI18n,
WithStyles<typeof styles>,
RouteComponentProps<any>,
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props> { 
}

interface IState {
    modalYoutube: boolean;
}
/*
   Avoid validateDOMNesting(...)
*/
const NewsContent = (message: any) => (ReactHtmlParser(message))

class PublicNewsDetail extends React.Component<IProps, IState> {

    state = {
        modalYoutube: false
    }

    componentDidMount(){
        this.props.fetchNews()
    }

    render() {
        const {t, classes, post, enterprise, mapName} = this.props
        return (
            <>
            {post &&
                <>
                    <HelmetMeta title={post.title}/>
                    <section className="section__landing relative" style={{backgroundImage: `url(${post.img_url ? post.img_url: "/assets/images/site/photo/news.jpg"})`}}>
                        <div className="section__content landing__text middle">
                            <h1 className="landing__title f-poppins">{post.title}</h1>
                            <p className="landing__sub-info f-poppins">{formatDate(post.publish_at)}</p>
                        </div>
                        {post.youtube_url &&
                            <>
                                <div className={classes.seeVideoBg}></div>
                                <Icon className={classes.seeVideo} onClick={this.toggleModalYoutube}>video_library</Icon>
                            </>
                        }
                    </section>
                    <section className="bg-white fullWidth">
                        <div className="section__content">
                            <div className="row">
                                <div className="col-md-push-8 col-md-4">
                                    <Typography variant="body2" style={{fontWeight: 'bold', marginLeft: '5px', marginBottom: '10px'}} className="f-poppins">{t.tags}</Typography>
                                    <div className={classes.tagsWpr}>
                                        <NewsTags news={post} classes={classes} mapName={mapName}/>
                                    </div>
                                </div>
                                <div className="col-md-pull-4 col-md-8">
                                    <div className="news-content f-poppins">{NewsContent(post.message)}</div>
                                    {post.documents.length > 0 &&
                                        <div className="text-center mg-t-2r" >
                                            {this.renderDocFile(post)}
                                        </div>
                                    }
                                    {!enterprise &&
                                        <div className="mg-t-1r mg-b-1r" >
                                            <p className="text-bold text-center f-poppins">Partager sur :</p>
                                            <NewsShare post={post} position="center"/>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                    {post.youtube_url &&
                        <PcDialog
                            maxWidth="lg"
                            open={this.state.modalYoutube}
                            onClose={this.toggleModalYoutube}
                        >
                            
                            <YouTube
                                videoId={getIdFormYoutubeUrl(post.youtube_url)}
                                className={classes.video}
                                opts={opts}
                            />
                        </PcDialog>
                    }
                </>
            }
            </>
        )
    }

    @autobind
    private toggleModalYoutube(){
        this.setState({modalYoutube: !this.state.modalYoutube})
    }

    @autobind
    private renderDocFile(news){
        const doc = news.documents.filter(d => getFileExtension(d.name) === "pdf")
        if(!!doc && doc.length > 0) {
            return (
                <a className="btn-outline nomargin pd-b-5 pd-t-5 pd-l-100 pd-r-100" href={doc[0].permalink}>
                    Télécharger le pdf
                </a>
            )
        } else {
            return ""
        }
    }

}

const dispatch2props = (dispatch: any, ownProps: any) => ({
    fetchNews: () => dispatch(getNews(ownProps.match.params.postId)),
})
const state2props = (state: RootState) => ({
    mapName: state.utils.mapCategories,
    post: state.post.entity,
    enterprise: state.accountInfo.enterpriseSelected,
})

export default compose(
    withI18n,
    withRouter,
    withStyles(styles),
    connect(state2props, dispatch2props)
)(PublicNewsDetail)


// WEBPACK FOOTER //
// ./src/page/PublicNews/PublicNewsDetail.tsx